import { createContext, useContext, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import en from '../resouces/en.json'
import fa from '../resouces/fa.json'

// export default function t(key) {
//     return selectedLanguage.data[key] ?? key
// }



const supportedLanguages = {
    en: { data: en, name: "English", direction: 'ltr' },
    fa: { data: fa, name: "فارسی", direction: 'rtl' }
}
const defaultLanguage = localStorage.getItem("language") ?? "en";
const language = defaultLanguage;

let selectedLanguage = supportedLanguages[language] ?? supportedLanguages["en"];



const setSelectedLanguage = (language,temp) => {
    
    
    selectedLanguage = supportedLanguages[language];
    if (!temp) {
        console.log('temp: ', temp);
        
        localStorage.setItem('language', language);
    }
}

var LocalizationContext = createContext();
export const languageList = Object.entries(supportedLanguages).map((values) => ({ code: values[0], name: values[1].name }));

export function LocalizationProvider(props) {
    const [language, setLanguage] = useState(defaultLanguage);
    const [direction, setDirection] = useState(supportedLanguages[defaultLanguage].direction);
    const settings = useSelector((state) => state.session.server);
    const [temp, setTemp] = useState(false);
    

    useEffect(() => {
        
        if (!temp && settings)
            handleLanguageChange(settings.language)
    }, [settings])

    const handleLanguageChange = (nextLanguage,temp) => {
        
        setTemp(temp);
        nextLanguage = nextLanguage == null || nextLanguage === 'null' || nextLanguage == undefined ? defaultLanguage  : nextLanguage;

        setSelectedLanguage(nextLanguage,temp);
        setLanguage(nextLanguage ?? 'en');
        setDirection(supportedLanguages[nextLanguage].direction)
        // window.location.reload();
    };

    return <LocalizationContext.Provider value={{ language, setLanguage: handleLanguageChange, languageList: supportedLanguages, direction , handleTemp : setTemp }}>
        {props.children}
    </LocalizationContext.Provider>
}

export const useLocalization = () => {
    return useContext(LocalizationContext);
}

export default function useTranslation() {
    const context = useContext(LocalizationContext);

    const { data } = context.languageList[context.language];
    
    return (key) => data[key]?? key;
}